import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * eventlevel API
 * @author Ju
 */
export default {
  /**
   * 이벤트 등급 목록을 조회한다.
   * @author Ju
   * @return {array}  이벤트 등급 배열
   */
  getList() {
    return axios.get(`${baseUrl}/frame/get-menu-info.do`);
  },
};



// WEBPACK FOOTER //
// ./src/api/model/menu-info.js